<template>
  <aside v-if="canSimulate" class="demo-error-tools" aria-label="Demo Tools">
    <span>Demo Tools</span>
    <CButton size="sm" color="light" :disabled="running" @click="simulate">Simulate Server Error</CButton>
  </aside>
</template>

<script>
import axios from 'axios'
import { demoErrorToolsEnabled } from '@/demoErrorToolsEnabled'

export default {
  name: 'DemoErrorTools',
  data () { return { canSimulate: false, running: false } },
  mounted () {
    if (!demoErrorToolsEnabled()) return

    axios.get(this.$apiAdress + '/api/demo/error-capability?token=' + localStorage.getItem('api_token'), { suppressGlobalError: true })
      .then(response => { this.canSimulate = response.data && response.data.can_simulate_error === true })
      .catch(() => { this.canSimulate = false })
  },
  methods: {
    simulate () {
      if (this.running) return
      window.Swal.fire({ title: 'Generate a demonstration error?', text: 'This will not submit or change the order.', icon: 'question', showCancelButton: true, confirmButtonText: 'Generate Demo Error', cancelButtonText: 'Cancel' }).then(result => {
        if (!result.isConfirmed) return
        this.running = true
        axios.post(this.$apiAdress + '/api/demo/simulate-server-error?token=' + localStorage.getItem('api_token'), {})
          .catch(() => {})
          .finally(() => { this.running = false })
      })
    }
  }
}
</script>

<style scoped>
.demo-error-tools { margin: 8px 16px; padding: 8px 10px; border: 1px dashed #b7c2cc; background: #f7f9fa; color: #596775; display: flex; justify-content: flex-end; align-items: center; gap: 10px; font-size: 12px; }
</style>
